/**
 * @hidden
 */
export var EMPTY_SELECTIONRANGE = { start: null, end: null };
//# sourceMappingURL=SelectionRange.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-dateinputs/dist/es/calendar/models/SelectionRange.js
// module id = 163
// module chunks = 0